import React from "react"
import moment from "moment"
import { v4 as uuidv4 } from 'uuid'
import {
  filter,
  map,
  toNumber,
  isEqual,
  sortBy,
  uniqBy,
  meanBy,
  isNaN,
  round,
  split,
  isObject,
  includes,
  join,
} from "lodash"
import { getDDMMYYYYFromMMDDYYYY, getTimestampFromDDMMYYYY, dateIsBetween } from "Utils/dateUtils"
import { getTypeRiskTranslated } from "Components/Governance/MappingRisksDetail/risk/components/listSelect.js"
import { getTradStatusAnoOrIncident } from "Components/Governance/Anomalies/utils"
import { isObjectV2 } from "Utils/global.js"
import { tag99Advisory, isAdministrator } from "Utils/checkAccess.js"
import {
  mandatoryFieldControlParameters,
  getIfControlParametersAreValid,
} from "Components/Governance/ControlParameter/utils.js"
import { getTypeOfControlSelectOptions } from "Containers/Governance/ControlParameter/utils"

export const headerHeight99Advisory = 80
export const filterGouvWidth = "180px"
// COLORS
export const darkBlue = "#0056a1"
export const veryDarkBlue = "#0B145C"
export const lightGrey = "#f6f6f6"
export const lightGreyV2 = "#EFEFEF"
export const middleGrey = "#cecece"
export const veryDarkGrey = "#404040"
export const middleBlue = "#0056a1"
export const lightBlue = "#2C6084"
export const whiteBlue = "#E3E9ED"
export const lightTurquoise = "#3d85a3"
export const redGrenat = "#D5003B"
export const greenValid = "#00771C"
export const redError = "#E70019"
export const orangeModifications = "#F99F38"
export const orangeWarning = "#e57709"
export const rougeWarning = "#A50025"
export const yellowWarning = "#e1a801"
export const middleGreyV2 = "#b1adad"
export const darkGrey = "#747575"
export const sweetGreen = "#48BF60"
export const sweetPink = "#F0BFBF"
export const sweetGrey = "#e3e1e1"

export const listControlStatus99 = [
  "notAffected",
  "affectedToConsultant",
  "waitingForControlModificationsValidation",
  "readyToBeAnswered",
]

export const listResponseStatus99 = [
  "draft",
  "validated",
  "validatedByManager",
  "validatedByClient",
]

// FUNCTIONS
export const getDateInfoActualWeek = mondayOfActualWeekMoment => {
  if (!mondayOfActualWeekMoment) {
    var infoDateComplete = {
      week: moment().week(),

      dayStart: moment().format("dddd"),
      numberStart: moment().format("D"),
      monthStart: moment().format("MM"),
      yearStart: moment().format("YYYY"),
      dayStartComparison: moment().format("DD/MM/YYYY"),

      dayEnd: moment().add(4, "days").format("dddd"),
      numberEnd: moment().add(4, "days").format("D"),
      monthEnd: moment().add(4, "days").format("MM"),
      yearEnd: moment().add(4, "days").format("YYYY"),
      dayEndComparison: moment().add(4, "days").format("DD/MM/YYYY"),
    }
  } else {
    const actualFriday = moment(mondayOfActualWeekMoment, "DD/MM/YYYY").add(4, "days")

    var infoDateComplete = {
      week: mondayOfActualWeekMoment.week(),

      dayStart: mondayOfActualWeekMoment.format("dddd"),
      numberStart: mondayOfActualWeekMoment.format("D"),
      monthStart: mondayOfActualWeekMoment.format("MM"),
      yearStart: mondayOfActualWeekMoment.format("YYYY"),
      dayStartComparison: mondayOfActualWeekMoment.format("DD/MM/YYYY"),

      dayEnd: actualFriday.format("dddd"),
      numberEnd: actualFriday.format("D"),
      monthEnd: actualFriday.format("MM"),
      yearEnd: actualFriday.format("YYYY"),
      dayEndComparison: actualFriday.format("DD/MM/YYYY"),
    }
  }
  return infoDateComplete
}

export const getDateInfoForFiveWeeks = (mondayOfActualWeekMoment, numberWeeksVisible = 5) => {
  let runningDate = moment(mondayOfActualWeekMoment)
  let totalInfoFiveWeeks = []

  for (let i = 0; i < numberWeeksVisible; i++) {
    let week = getDateInfoActualWeek(runningDate)
    totalInfoFiveWeeks.push(week)
    runningDate.add(7, "days")
  }
  return totalInfoFiveWeeks
}

export const getMonthInfos = actualDate => {
  let monthInfo = {}
  if (!actualDate) return monthInfo
  monthInfo = {
    monthLetter: actualDate.format("MMM"),
    dayStartComparison: actualDate.startOf("month").format("DD/MM/YYYY"),
    dayEndComparison: actualDate.endOf("month").format("DD/MM/YYYY"),
    monthYearEnd: actualDate.format("YYYY"),
  }
  return monthInfo
}

export const getMonthsToShow = (mondayOfActualWeekMoment, numberMonthsToDisplay = 6) => {
  let runningDate = moment(mondayOfActualWeekMoment)
  let listNextMonths = []

  for (let i = 0; i < numberMonthsToDisplay; i++) {
    let monthFormated = getMonthInfos(runningDate)
    listNextMonths.push(monthFormated)
    runningDate.add(1, "M")
  }
  return listNextMonths
}

export const getDateReduceUppercase = monday => {
  const reduceDate = monday.charAt(0)?.toUpperCase() + monday.slice(1, 2)
  return reduceDate
}

export const getDateFormatMoment = date => {
  const dateSplit = date?.split("/")
  const newDate = dateSplit[1] + "-" + dateSplit[0] + "-" + dateSplit[2]
  const momentDate = moment(newDate)
  return momentDate
}

export const getRiskControl = risk => {
  switch (risk) {
    case "Très faible":
      return 0
    case "Faible":
      return 1
    case "Modéré":
      return 2
    case "Fort":
      return 3
    case "Critique":
      return 4
    case "Très fort":
      return 4
    default:
      return 0
  }
}

export const getDegreeRisk = (risk, trad) => {
  switch (risk) {
    case 0:
      return <p>{trad.VERYLOW}</p>
    case 1:
      return <p>{trad.LOW}</p>
    case 2:
      return <p>{trad.MODERATE}</p>
    case 3:
      return <p>{trad.HIGH}</p>
    case 4:
      return <p>{trad.CRITICAL}</p>
    default:
      return <p>{trad.VERYLOW}</p>
  }
}

export const getDegreeColor = degree => {
  const valueDegree = degree?.toLowerCase()
  switch (valueDegree) {
    case "très faible":
      return "#3992AF"
    case "faible":
      return "#86D195"
    case "modéré":
    case "modérée":
      return "#DEB33D"
    case "fort":
    case "elevée":
    case "élevée":
      return "#e3660d"
    case "critique":
    case "très fort":
    case "très élevée":
      return "#FB0404"
    default:
      return "#3992AF"
  }
}
export const getCardFromFullControl = (fullControl, responses) => {
  if (!fullControl || !Array.isArray(responses)) return {}
  const { template, control } = fullControl
  const { startDate, period, achievementPeriod = {} } = control || {}

  const templateId = template?._id?.$oid
  // Récupération réponse par card
  const responsesAssociated = responses?.filter(rep => rep?.idTemplate === templateId)
  const templateHasResponse = Array.isArray(responsesAssociated) && responsesAssociated.length > 0
  const firstResponse = templateHasResponse
    ? responsesAssociated[0]
    : { response: [], userName: "" }

  const reponseTemplate = firstResponse?.response || firstResponse?.reponse
  const nameRespondant = firstResponse?.userName

  // ================ Statut de la card par rapport a la période Occurence ================
  const timeStampToday = new Date().setHours(0, 0, 0, 0)
  const startDateOccurenceTimeStamp = moment(getDDMMYYYYFromMMDDYYYY(startDate)).format("X") * 1000
  const endDateOccurence = getEndDateOnPeriod(startDate, period)
  const endDateOccurenceTimeStamp =
    moment(getDDMMYYYYFromMMDDYYYY(endDateOccurence)).format("X") * 1000
  const statusCardTmp = templateHasResponse ? "finished" : ""
  const statusCard =
    startDateOccurenceTimeStamp >= timeStampToday || timeStampToday >= endDateOccurenceTimeStamp
      ? "closed"
      : statusCardTmp

  let valueConformity = ""

  if (firstResponse?.status === "validated") valueConformity = "Terminé"
  else if (reponseTemplate?.length) valueConformity = "en cours"
  else if (statusCard === "finished") valueConformity = "Terminé"
  else valueConformity = "à réaliser"

  const { startAchievementPeriod, endAchievementPeriod } = getStartAndEndAchievementPeriod(
    startDate,
    endDateOccurence,
    achievementPeriod
  )

  return {
    ...fullControl,
    id: templateId,
    idTemplate: templateId,
    statut: statusCard,
    number: {
      value: control?.reference,
      color: control?.color,
    },
    title: control?.process,
    description: control?.description,
    level: toNumber(control?.level) || "-",
    risk: getRiskControl(control?.riskBrut),
    riskName: control?.riskName,
    activityName: control?.activityName,
    period: control?.period,
    controleur: control?.controller,
    echantillon: control?.sample,
    conformity: valueConformity,
    date: control?.date,
    startDate: control?.startDate,
    endDate: control?.endDate,
    startDateOccurence: control?.startDate,
    endDateOccurence: control?.isBusinessDaysDate ? control?.endDate : endDateOccurence,
    ...(achievementPeriod && { achievementPeriod: achievementPeriod }),
    startAchievementPeriod: startAchievementPeriod,
    endAchievementPeriod: endAchievementPeriod,
    startDateOccurenceTimeStamp: startDateOccurenceTimeStamp,
    endDateOccurenceTimeStamp: endDateOccurenceTimeStamp,
    structure_template: template?.structure_template,
    regulatoryReferences: control?.regulatoryReferences,
    requestedDocuments: control?.requestedDocuments,
    responseCard: reponseTemplate,
    nameRespondant: nameRespondant,
  }
}
export const formatDataCards = (fullControls, responses) => {
  if (!Array.isArray(fullControls) || !Array.isArray(responses)) return []
  const fullControlsAvailable = fullControls?.filter(fullControl =>
    fullControl?.hasOwnProperty("control")
  )
  return fullControlsAvailable?.map(fullControl => getCardFromFullControl(fullControl, responses))
}

export const relationResponseCards = (cards, response, myBusinessTag) => {
  const cardsWithResponses = cards.map(cardControl => {
    const { endDate, date, idTemplate, control } = cardControl
    const dateToUse = endDate ? endDate : date
    const numberWeekCard = moment(getDDMMYYYYFromMMDDYYYY(dateToUse)).week()

    const checkReponseTemplate = response.filter(
      rep => rep.idOccurence === idTemplate + "-" + dateToUse
    )
    const [firstResponseTemplate] = checkReponseTemplate || []
    const responseTemplate = firstResponseTemplate?.reponse || []
    const responseDocuments = firstResponseTemplate?.documents || []

    const checkReponseTemplateWithoutDraft = checkReponseTemplate.filter(
      rep => rep?.status !== "draft"
    )

    const responseStatus = firstResponseTemplate?.status
    const controlStatus = control?.status

    const statusCardTmp = checkReponseTemplateWithoutDraft.length > 0 ? "finished" : ""
    const statusCardClose = getIfControlClosed(cardControl, numberWeekCard)
      ? "closed"
      : statusCardTmp
    const occurenceStatus = getOccurenceCardStatus(controlStatus, responseStatus)

    const deadLineControlExceed = getIfPastControlDate(cardControl, numberWeekCard)
    const statusCard =
      deadLineControlExceed && statusCardTmp === ""
        ? "deadlineExceed"
        : deadLineControlExceed
        ? "closedReadOnly"
        : statusCardClose

    const meanDefault = getMeanDefaultConformity(myBusinessTag)
    const conformityStatus = getControlConformityStatus(firstResponseTemplate, meanDefault)

    return {
      ...cardControl,
      responseCard: responseTemplate,
      idResponse: firstResponseTemplate?._id,
      responseStatus,
      conformity: conformityStatus,
      statut: statusCard,
      numberWeekCard,
      responseDocuments,
      occurenceStatus,
    }
  })

  return cardsWithResponses
}

export const businessClientCards = (cards, controlPlans = [], businessGroups = []) => {
  if (!Array.isArray(cards) || !Array.isArray(controlPlans) || !Array.isArray(businessGroups)) {
    return []
  }

  const newData = cards?.map(card => {
    const controlPlanId = card?.control?.controlPlanId
    const controlPlan = controlPlans?.find(controlPlan => controlPlan?._id?.$oid === controlPlanId)
    const clientId = controlPlan ? controlPlan?.clientId : ""
    const group = businessGroups?.filter(group => group?._id?.$oid === clientId)
    const clientName = group ? group[0]?.name : ""
    const controlPlanResponsiblesIds = controlPlan?.responsiblesIds || []
    return { ...card, clientId, clientName, controlPlanResponsiblesIds }
  })
  return newData
}

// Définir la conformité d'un controle par rapport au différent point de controle (Plan de controle)
export const getAverageNotation = responses => {
  // Moyenne des différents question de degrée conformité
  const valuesDegreeConformity = map(responses, item => item?.value_question)
  const filterReponseDegree = filter(
    valuesDegreeConformity,
    item => item?.value >= 0 || item?.value === -1
  )
  const filterReponseWithoutNA = filter(valuesDegreeConformity, item => item?.value >= 0)
  const filterReponseNA = filter(valuesDegreeConformity, item => item?.value === -1)
  // Moyenne de toute les questions
  const meanDegreeConformityAll = meanBy(valuesDegreeConformity, "value")
  // Moyenne en retirant les réponses NA
  const meanDegreeConformityWithoutNATmp = meanBy(filterReponseWithoutNA, "value")
  const meanDegreeConformityWithoutNA = isNaN(meanDegreeConformityWithoutNATmp)
    ? 0
    : round(meanDegreeConformityWithoutNATmp, 2)
  // Note de conformité
  const valueConformity =
    filterReponseNA.length === filterReponseDegree.length ? "NA" : meanDegreeConformityWithoutNA
  return valueConformity
}

export const getMaximumAverageNotation = responses => {
  const values = map(responses, item => item?.value_question?.value).filter(
    val => typeof val === "number"
  )
  return values.length ? Math.max(...values) : null
}

// Définir la conformité d'un controle par rapport au différent point de controle (Plan de controle)
export const getConformityDegreeConformity = (data, meanConformityBusiness) => {
  // Moyenne des différents question de degrée conformité
  const valuesDegreeConformity = map(data, item => item?.value_question)
  const filterReponseDegree = filter(
    valuesDegreeConformity,
    item => item?.value >= 0 || item?.value === -1
  )
  const filterReponseWithoutNA = filter(valuesDegreeConformity, item => item?.value >= 0)
  const filterReponseNA = filter(valuesDegreeConformity, item => item?.value === -1)
  // Moyenne de toute les questions
  const meanDegreeConformityAll = meanBy(valuesDegreeConformity, "value")
  // Moyenne en retirant les réponses NA
  const meanDegreeConformityWithoutNATmp = meanBy(filterReponseWithoutNA, "value")
  const meanDegreeConformityWithoutNA = isNaN(meanDegreeConformityWithoutNATmp)
    ? 0
    : round(meanDegreeConformityWithoutNATmp, 2)
  // comparaison a la note de conformité
  const valueConformity =
    filterReponseNA.length === filterReponseDegree.length
      ? "NA"
      : getMeanConformityControle(meanDegreeConformityWithoutNA, meanConformityBusiness)
  return valueConformity
}
// Définir la conformité d'un controle par rapport à la note moyenne (Plan de controle)
export const getMeanConformityControle = (meanConformityControl, meanConformityBusiness) => {
  if (toNumber(meanConformityControl)) {
    if (meanConformityControl > meanConformityBusiness?.faibleImpactMax) {
      return "Conforme"
    } else if (
      meanConformityControl <= meanConformityBusiness?.faibleImpactMax &&
      meanConformityControl >= meanConformityBusiness?.faibleImpactMin
    ) {
      return "Partiellement conforme avec un faible impact"
    } else if (
      meanConformityControl <= meanConformityBusiness?.fortImpactMax &&
      meanConformityControl >= meanConformityBusiness?.fortImpactMin
    ) {
      return "Partiellement conforme avec un fort impact"
    } else if (
      meanConformityControl <= meanConformityBusiness?.nonConformeMax &&
      meanConformityControl >= meanConformityBusiness?.nonConformeMin
    ) {
      return "Non Conforme"
    } else {
      return "NA"
    }
  } else {
    if (meanConformityControl === "0" || meanConformityControl === 0) {
      return "Non Conforme"
    } else if (meanConformityControl === "NA") {
      return "NA"
    } else {
      return "-"
    }
  }
}
// Moyenne par default ou par business
export const getMeanDefaultConformity = (myBusinessTag = "99advisory") => {
  const echelleConformityDefault = {
    conforme: 3,
    faibleImpactMax: 2.99,
    faibleImpactMin: 1.8,
    fortImpactMax: 1.79,
    fortImpactMin: 0.6,
    nonConformeMax: 0.59,
    nonConformeMin: 0,
  }
  switch (myBusinessTag) {
    case "99advisory":
      return echelleConformityDefault
    default:
      return echelleConformityDefault
  }
}

/**Create a new list a one year occurences ( 12 month, 4 trimesters, 2 semesters) */
export const createOccurencesControls = listControls => {
  if (!Array.isArray(listControls) || listControls.length === 0) return []
  const controlsOccurencies = []
  // Créer une fonction qui renvoie les occurence
  listControls.forEach(control => {
    const listOccurenceControls = getControlOccurences(control) || []
    controlsOccurencies.push(...listOccurenceControls)
  })
  return controlsOccurencies
}

const checkIsCardAlreadyInList = (cardToCheck, listCard) => {
  const cardCopy = [...listCard]
  let isCardInList = false
  let cardWithoutId = { ...cardToCheck }
  delete cardWithoutId.id
  delete cardWithoutId.conformity
  delete cardWithoutId.responseCard
  delete cardWithoutId.statut
  cardCopy.forEach(card => {
    const testCard = { ...card }
    delete testCard.id
    delete testCard.conformity
    delete testCard.responseCard
    delete testCard.statut
    if (isEqual(card, cardCopy)) isCardInList = true
  })

  return isCardInList
}
// formatage Liste Activity
export const transformListActivity = data => {
  const dataList = map(data, item => {
    const labelName =
      item?.reference !== "" && item?.reference ? item?.reference + " - " + item?.name : item?.name
    return {
      value: item?._id?.$oid,
      label: labelName,
      item: item,
    }
  })

  const sortList = sortBy(dataList, "label")

  return sortList
}
// formatage Liste Risk
export const getRiskLabel = risk => {
  const riskReference = risk?.reference
  const riskName = risk?.name
  if (!riskReference || riskReference === "") return riskName
  return `${riskReference} - ${riskName}`
}

export const transformListSelectRisk = (risks, idActivity) => {
  if (!Array.isArray(risks)) return []
  let risksByActivity = []
  if (!idActivity) risksByActivity = risks
  else risksByActivity = risks.filter(risk => risk?.activity === idActivity)

  const optionsSelectRisk = risksByActivity.map(risk => {
    const label = getRiskLabel(risk)
    return {
      value: risk?._id?.$oid,
      label: label,
      item: risk,
    }
  })

  const sortList = sortBy(optionsSelectRisk, "label")
  return sortList
}

export const getRisksFilteredByActivities = (risks, activities) => {
  if (!Array.isArray(risks) || !Array.isArray(activities)) return []
  const activitiesIds = activities.map(activity => activity?._id?.$oid)
  return risks.filter(risk => activitiesIds.includes(risk?.activity))
}

// Check champs vide
export const checkValidationFormControl = (fullControl, myBusiness) => {
  let checkForm = {
    checkTemplate: false,
    checkOneTargetUser: false,
    checkParameters: false,
    checkDate: false,
    checkRowResult: false,
  }
  if (!fullControl || !fullControl?.control || !fullControl?.template) return checkForm

  // check structure templates vide
  const stuctureTemplate = fullControl?.template?.structure_template
  const checkEmptyTemplate = stuctureTemplate?.length > 0
  checkForm.checkTemplate = checkEmptyTemplate

  // check présence d'une ligne de résultat dans le template si le type est un contrôle
  const checkTypeControle = fullControl?.control?.type_control === "controle"
  const checkTypeMitigant = fullControl?.control?.type_control === "mitigant"
  const checkResultatInTemplate = checkEmptyTemplate
    ? stuctureTemplate?.filter(row => row?.type === "result")?.length > 0
    : false
  const checkResultat =
    checkEmptyTemplate && checkTypeControle ? checkResultatInTemplate : checkTypeMitigant
  checkForm.checkRowResult = checkResultat
  // check users affecté vide
  checkForm.checkOneTargetUser =
    fullControl?.control?.targetUsers?.length > 0 ||
    fullControl?.control?.targetUsers?.usersIds?.length > 0

  // check parametres control vide
  const controlParametersAreValid = getIfControlParametersAreValid(
    fullControl?.control,
    mandatoryFieldControlParameters,
    myBusiness
  )

  let riskIsPresent
  if (fullControl?.control?.riskIds) riskIsPresent = fullControl?.control?.riskIds?.length > 0
  else riskIsPresent = fullControl?.control?.risk !== ""

  checkForm.checkParameters = controlParametersAreValid && riskIsPresent
  checkForm.checkDate = !verifyIfDatesAreInvalid(fullControl?.control)
  return checkForm
}
// Récuperation des données pour créer les options d'un select
export const transformDataInSelect = (data, type, trad) => {
  if (!Array.isArray(data)) return []
  const selectData = map(data, item => {
    let valueSelect = {
      label: item[type],
      value: item[type],
    }

    switch (type) {
      case "impact":
        valueSelect.label = getImpactTranslated(item[type], trad)
        break
      case "frequency":
        valueSelect.label = getFrequencyTranslated(item[type], trad)
        break
      case "riskBrut":
      case "riskResidual":
        valueSelect.label = getRiskBrutTranslated(item[type], trad)
        break
      case "typeRisk":
      case "type_risk":
        valueSelect.label = getTypeRiskTranslated(item[type], trad)
        break
      case "type_control":
        valueSelect.label = getTypeControlTranslated(item[type], trad)
        break
      case "period":
        valueSelect.label = getPeriodTranslated(item[type], trad)
        break
      case "status":
        valueSelect.label = getTradStatusAnoOrIncident(trad, item[type])
        break
      // case "createdDate":
      //   valueSelect.label = formatDateJJMMAAAA(item[type])
      default:
        break
    }

    return valueSelect
  })
  const selectOption = sortBy(uniqBy(selectData, "value"), "label")
  const selectOptionFilter = filter(selectOption, item => item?.label)

  return selectOptionFilter
}

const formatDateJJMMAAAA = dateString => {
  const date = new Date(dateString)

  // Extraire le jour, le mois, et l'année en utilisant les méthodes UTC
  const day = date.getUTCDate().toString().padStart(2, "0")
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0")
  const year = date.getUTCFullYear()

  // Formater la date en JJ/MM/AAAA
  return `${day}/${month}/${year}`
}

export const transformActivityInSelect = data => {
  const selectData = map(data, ({ activity }) => {
    return {
      label: `${activity.reference} - ${activity.name}`,
      value: `${activity._id.$oid}`,
    }
  })

  return uniqBy(selectData, "value")
}

export const transform2LevelObjectDataInSelect = (data, firstType, secondType) => {
  const selectData = data?.map(item => {
    return {
      label: item?.[firstType]?.[secondType],
      value: item?.[firstType]?.[secondType],
    }
  })
  const selectOption = sortBy(uniqBy(selectData, "value"), "label")
  const selectOptionFilter = selectOption.filter(item => item?.label)
  return selectOptionFilter
}
// Ajout d'une nouvelle clé aux objets d'un tableau pour pouvoir le trier par date par la suite
export const addDateMomentBeforeSort = array => {
  if (!Array.isArray(array)) return {}
  const newArray = [...array]
  return newArray?.map(obj => {
    if (obj.date) {
      let timeStamp = getTimestampFromDDMMYYYY(obj.date)
      return { ...obj, dateTimeStamp: timeStamp }
    } else {
      let startDateTimeStamp = getTimestampFromDDMMYYYY(obj.startDate)
      return { ...obj, dateTimeStamp: startDateTimeStamp }
    }
  })
}

// Tri et renvoi d'un tableau grâce aux dates format moment
export const getCardsListSortedByDate = cardsLists => {
  let cardsListWithDateMoment = addDateMomentBeforeSort(cardsLists)
  let cardsListSorted = cardsListWithDateMoment.sort((a, b) => a.dateTimeStamp - b.dateTimeStamp)
  return cardsListSorted
}

export const hideCardsPast = (occurrences = [], hidePassedControl = true, todayFirstTimeStamp) => {
  if (!hidePassedControl) return occurrences
  return occurrences.filter(occu => {
    return occu?.period === "Quotidienne" ? occu?.dateTimeStamp >= todayFirstTimeStamp : true
  })
}

export const getDateWithBusinessDays = e => {
  const numberBusinessDays = e.value
  const firstDayActualMonth = moment().startOf("month").format("DD/MM/YYYY")
  const date = moment(firstDayActualMonth, "DD/MM/YYYY").businessAdd(numberBusinessDays)._d
  const dateFormated = moment(date).format("DD/MM/YYYY")
  return dateFormated
}

export const getBusinessDaysWithDate = date => {
  if (!date) return ""
  const firstDayMonth = moment(date, "DD/MM/YYYY").startOf("month").format("DD/MM/YYYY")
  const numberBusinessDays = moment(date, "DD/MM/YYYY").businessDiff(
    moment(firstDayMonth, "DD/MM/YYYY")
  )
  return numberBusinessDays + 1
}

// ------------------------------------------------//
// ------------ GESTION DES OCCURENCES ------------//
// ------------------------------------------------//
export const nbsOccurencesToCreateByType = {
  Quotidienne: 1460,
  Hebdomadaire: 208,
  Mensuelle: 48,
  Trimestrielle: 16,
  Semestrielle: 8,
  Annuelle: 4,
}

export const getNbOccurencesToCreate = elementType => {
  const numberYearsToCalculOccurences = 4 // On calcule les occurences pendant X années
  const numberOfElementsByYear = {
    Quotidienne: 260, // numberWorkingDaysPerYear
    Hebdomadaire: 52,
    Mensuelle: 12,
    Trimestrielle: 3,
    Semestrielle: 2,
    Annuelle: 1,
  }
  return numberOfElementsByYear[elementType] * numberYearsToCalculOccurences
}

export const getControlOccurences = card => {
  const listOccurences = [{ ...card }]
  const period = card?.period
  const achievementPeriod = card?.achievementPeriod
  const parameterStartDate = card?.startDate
  const nbOccurencesToCreate = getNbOccurencesToCreate(period)

  if (period === "Quotidienne") {
    let dailyDate = parameterStartDate
    if (!nbOccurencesToCreate || typeof nbOccurencesToCreate !== "number") return
    for (let i = 1; i <= nbOccurencesToCreate; i++) {
      const newDate = moment(dailyDate, "DD/MM/YYYY").businessAdd(i)._d
      const newDateFrenchFormat = moment(newDate).format("DD/MM/YYYY")
      const timeStampToday = Date.now()
      const timeStampDayStart = toNumber(moment(newDate).format("x"))
      const timeStampDayEnd = toNumber(moment(newDate).format("x"))
      const { startAchievementPeriod, endAchievementPeriod } = getStartAndEndAchievementPeriod(
        newDateFrenchFormat,
        newDateFrenchFormat,
        achievementPeriod
      )

      const weekCard = {
        ...card,
        id: uuidv4(),
        startDate: newDateFrenchFormat,
        endDate: newDateFrenchFormat,
        startDateOccurence: newDateFrenchFormat,
        endDateOccurence: newDateFrenchFormat,
        startDateOccurenceTimeStamp: timeStampDayStart,
        endDateOccurenceTimeStamp: timeStampDayEnd,
        startAchievementPeriod: startAchievementPeriod,
        endAchievementPeriod: endAchievementPeriod,
      }
      listOccurences.push({
        ...weekCard,
        statut:
          timeStampToday < timeStampDayStart || timeStampToday > timeStampDayEnd ? "closed" : "",
        conformity: "à réaliser",
      })
    }
  } else if (period === "Hebdomadaire") {
    let weeklyDate = parameterStartDate
    if (!nbOccurencesToCreate || typeof nbOccurencesToCreate !== "number") return
    for (let i = 1; i <= nbOccurencesToCreate; i++) {
      const newDate = moment(weeklyDate, "DD/MM/YYYY").add(i, "week").format("DD/MM/YYYY")
      const timeStampToday = Date.now()
      const timeStampDayStart = toNumber(moment(newDate).format("x"))
      const timeStampDayEnd = getDateInTimeStampFrequenceControl(timeStampDayStart, "Hebdomadaire")
      const endDateOccurence = getOcurrenceEndDateOnPeriod(newDate, 7, "days")
      const { startAchievementPeriod, endAchievementPeriod } = getStartAndEndAchievementPeriod(
        newDate,
        endDateOccurence,
        achievementPeriod
      )

      const weekCard = {
        ...card,
        id: uuidv4(),
        startDate: newDate,
        endDate: newDate,
        startDateOccurence: newDate,
        endDateOccurence: endDateOccurence,
        startDateOccurenceTimeStamp: timeStampDayStart,
        endDateOccurenceTimeStamp: timeStampDayEnd,
        startAchievementPeriod: startAchievementPeriod,
        endAchievementPeriod: endAchievementPeriod,
      }
      listOccurences.push({
        ...weekCard,
        statut:
          timeStampToday < timeStampDayStart || timeStampToday > timeStampDayEnd ? "closed" : "",
        conformity: "à réaliser",
      })
    }
  } else if (period === "Mensuelle") {
    let monthlyDate = parameterStartDate
    if (!nbOccurencesToCreate || typeof nbOccurencesToCreate !== "number") return
    for (let i = 1; i <= nbOccurencesToCreate; i++) {
      const newDate = moment(monthlyDate, "DD/MM/YYYY").add(i, "month").format("DD/MM/YYYY")
      const timeStampToday = Date.now()
      const timeStampDayStart = toNumber(moment(newDate).format("x"))

      // const timeStampDayEnd = moment(newDate).format("x")
      const timeStampDayEnd = getDateInTimeStampFrequenceControl(timeStampDayStart, "Mensuelle")
      const endDateOccurence = getOcurrenceEndDateOnPeriod(newDate, 1, "months")
      const { startAchievementPeriod, endAchievementPeriod } = getStartAndEndAchievementPeriod(
        newDate,
        endDateOccurence,
        achievementPeriod
      )

      const weekCard = {
        ...card,
        id: uuidv4(),
        startDate: newDate,
        endDate: newDate,
        startDateOccurence: newDate,
        endDateOccurence: endDateOccurence,
        startDateOccurenceTimeStamp: timeStampDayStart,
        endDateOccurenceTimeStamp: timeStampDayEnd,
        startAchievementPeriod: startAchievementPeriod,
        endAchievementPeriod: endAchievementPeriod,
      }
      listOccurences.push({
        ...weekCard,
        statut:
          timeStampToday < timeStampDayStart || timeStampToday > timeStampDayEnd ? "closed" : "",
        conformity: "à réaliser",
      })
    }
  } else if (period === "Trimestrielle") {
    if (!nbOccurencesToCreate || typeof nbOccurencesToCreate !== "number") return
    let trimesterDate = parameterStartDate
    for (let i = 1; i <= nbOccurencesToCreate; i++) {
      trimesterDate = moment(trimesterDate, "DD/MM/YYYY").add(3, "month").format("DD/MM/YYYY")
      const timeStampToday = Date.now()
      const timeStampDayStart = toNumber(moment(trimesterDate).format("x"))
      // const timeStampDayEnd = moment(trimesterDate).format("x")
      const timeStampDayEnd = getDateInTimeStampFrequenceControl(timeStampDayStart, "Trimestrielle")
      const endDateOccurence = getOcurrenceEndDateOnPeriod(trimesterDate, 3, "months")
      const { startAchievementPeriod, endAchievementPeriod } = getStartAndEndAchievementPeriod(
        trimesterDate,
        endDateOccurence,
        achievementPeriod
      )

      const weekCard = {
        ...card,
        id: uuidv4(),
        startDate: trimesterDate,
        endDate: trimesterDate,
        startDateOccurence: trimesterDate,
        endDateOccurence: endDateOccurence,
        startDateOccurenceTimeStamp: timeStampDayStart,
        endDateOccurenceTimeStamp: timeStampDayEnd,
        startAchievementPeriod: startAchievementPeriod,
        endAchievementPeriod: endAchievementPeriod,
      }
      listOccurences.push({
        ...weekCard,
        statut:
          timeStampToday < timeStampDayStart || timeStampToday > timeStampDayEnd ? "closed" : "",
        conformity: "à réaliser",
      })
    }
  } else if (period === "Semestrielle") {
    if (!nbOccurencesToCreate || typeof nbOccurencesToCreate !== "number") return
    let semesterDate = parameterStartDate
    for (let i = 1; i <= nbOccurencesToCreate; i++) {
      semesterDate = moment(semesterDate, "DD/MM/YYYY").add(6, "month").format("DD/MM/YYYY")
      const timeStampToday = Date.now()
      const timeStampDayStart = toNumber(moment(semesterDate).format("x"))
      // const timeStampDayEnd = moment(semesterDate).format("x")
      const timeStampDayEnd = getDateInTimeStampFrequenceControl(timeStampDayStart, "Semestrielle")
      const endDateOccurence = getOcurrenceEndDateOnPeriod(semesterDate, 6, "months")
      const { startAchievementPeriod, endAchievementPeriod } = getStartAndEndAchievementPeriod(
        semesterDate,
        endDateOccurence,
        achievementPeriod
      )

      const weekCard = {
        ...card,
        id: uuidv4(),
        startDate: semesterDate,
        endDate: semesterDate,
        startDateOccurence: semesterDate,
        endDateOccurence: endDateOccurence,
        startDateOccurenceTimeStamp: timeStampDayStart,
        endDateOccurenceTimeStamp: timeStampDayEnd,
        startAchievementPeriod: startAchievementPeriod,
        endAchievementPeriod: endAchievementPeriod,
      }
      listOccurences.push({
        ...weekCard,
        statut:
          timeStampToday < timeStampDayStart || timeStampToday > timeStampDayEnd ? "closed" : "",
        conformity: "à réaliser",
      })
    }
  } else if (period === "Annuelle") {
    if (!nbOccurencesToCreate || typeof nbOccurencesToCreate !== "number") return
    let annualDate = parameterStartDate
    for (let i = 1; i <= nbOccurencesToCreate; i++) {
      annualDate = moment(annualDate, "DD/MM/YYYY").add(1, "year").format("DD/MM/YYYY")
      const timeStampToday = Date.now()
      const timeStampDayStart = toNumber(moment(annualDate).format("x"))
      // const timeStampDayEnd = moment(annualDate).format("x")
      const timeStampDayEnd = getDateInTimeStampFrequenceControl(timeStampDayStart, "Annuelle")
      const endDateOccurence = getOcurrenceEndDateOnPeriod(annualDate, 1, "year")
      const { startAchievementPeriod, endAchievementPeriod } = getStartAndEndAchievementPeriod(
        annualDate,
        endDateOccurence,
        achievementPeriod
      )

      const weekCard = {
        ...card,
        id: uuidv4(),
        startDate: annualDate,
        endDate: annualDate,
        startDateOccurence: annualDate,
        endDateOccurence: endDateOccurence,
        startDateOccurenceTimeStamp: timeStampDayStart,
        endDateOccurenceTimeStamp: timeStampDayEnd,
        startAchievementPeriod: startAchievementPeriod,
        endAchievementPeriod: endAchievementPeriod,
      }
      listOccurences.push({
        ...weekCard,
        statut:
          timeStampToday < timeStampDayStart || timeStampToday > timeStampDayEnd ? "closed" : "",
        conformity: "à réaliser",
      })
    }
  }
  return listOccurences
}
// ------------------------------------------------//
// ------------------------------------------------//
// ------------------------------------------------//

export const controlShouldBeDisplayOnPlanning = timeStampInfos => {
  const { controlStart, controlEnd, planningStart, planningEnd } = timeStampInfos

  const planningRange = [planningStart, planningEnd]
  const planningContainCardStart = dateIsBetween(controlStart, planningRange)
  const planningContainCardEnd = dateIsBetween(controlEnd, planningRange)
  const planningContainFullCard = controlStart <= planningStart && controlEnd >= planningEnd

  return planningContainFullCard || planningContainCardEnd || planningContainCardStart
}

export const controlSimpleShouldBeDisplayOnPlanning = timeStampInfos => {
  const { controlSimpleDate, planningStart, planningEnd } = timeStampInfos

  const controlIsBetweenRangePlanning =
    controlSimpleDate >= planningStart && controlSimpleDate <= planningEnd
  return controlIsBetweenRangePlanning
}

export const displayControlPlanning = (occurrence = {}, planningStartDate, planningEndDate) => {
  if (!occurrence || !planningStartDate || !planningEndDate) return false

  const { startDateOccurence, endDateOccurence, date } = occurrence

  // get planning TS
  const planningStartTimeStamp = getTimestampFromDDMMYYYY(planningStartDate)
  const planningEndTimeStamp = getTimestampFromDDMMYYYY(planningEndDate)
  // get controls TS
  const controlStartTimeStamp = getTimestampFromDDMMYYYY(startDateOccurence)
  const controlEndTimeStamp = getTimestampFromDDMMYYYY(endDateOccurence)

  const controlSimpleDateTimeStamp = getTimestampFromDDMMYYYY(date)

  const timeStampInfos = {
    planningStart: planningStartTimeStamp,
    planningEnd: planningEndTimeStamp,
    controlStart: controlStartTimeStamp,
    controlEnd: controlEndTimeStamp,
    controlSimpleDate: controlSimpleDateTimeStamp,
  }

  let controlShouldBeDisplay = false
  if (startDateOccurence) controlShouldBeDisplay = controlShouldBeDisplayOnPlanning(timeStampInfos)
  if (date) controlShouldBeDisplay = controlSimpleShouldBeDisplayOnPlanning(timeStampInfos)

  return controlShouldBeDisplay
}

const frenchDateRegex = /^([0-9]|[0-2][0-9]|(3)[0-1])(\/)(([0-9]|(0)[0-9])|((1)[0-2]))(\/)\d{4}$/
const DDMMYYYYDateRegex = /^((0)[1-9]|[1-2][0-9]|(3)[0-1])(\/)((0)[1-9]|((1)[0-2]))(\/)\d{4}$/
const isoDurationRegex =
  /P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)W)?(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?)?$/

const isIsoDuration = isoDuration => isoDurationRegex.test(isoDuration)

export const parseISODuration = isoDuration => {
  const [, years, months, weeks, days, hours, minutes, secs] = isoDuration.match(isoDurationRegex)
  return [years, months, weeks, days, hours, minutes, secs].map(val => {
    if (val === undefined) return 0
    return parseInt(val)
  })
}

const isDDMMYYYYDate = date => DDMMYYYYDateRegex.test(date)

export const getIsoDateFromStartAndPeriod = (startDate, achievementPeriod) => {
  if (!isIsoDuration(achievementPeriod)) return undefined
  const [years, months, weeks, days, hours, minutes, secs] = parseISODuration(achievementPeriod)
  const durationToAdd = {
    years: years,
    months: months,
    weeks: weeks,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: secs,
  }

  if (isDDMMYYYYDate(startDate)) {
    return moment.utc(startDate, "DD/MM/YYYY").add(durationToAdd).toISOString()
  }
  return moment.utc(startDate).add(durationToAdd).toISOString()
}

export const parsedDurationHasOnlyMonths = (parsedDuration = []) => {
  if (!Array.isArray(parsedDuration)) return false

  return parsedDuration.reduce((acc, current, index) => {
    return acc && (index === 1 || (index !== 1 && current === 0))
  }, true)
}

export const achievementPeriodIsLongerThanPeriod = (achievementPeriod, controlPeriod) => {
  if (!achievementPeriod || !controlPeriod) return false
  const { startOffset, endOffset } = achievementPeriod
  const parsedDuration = parseISODuration(endOffset)
  const [years, months, weeks, days, hours, minutes, secs] = parsedDuration
  //EASY CASE
  if (startOffset === "P0M" && parsedDurationHasOnlyMonths(parsedDuration)) {
    if (controlPeriod === "Trimestrielle") return months >= 3
    if (controlPeriod === "Semestrielle") return months >= 6
    if (controlPeriod === "Annuelle") return months >= 12
  }
  //HARD CASE
  //startOffset === "P0W" et endOffset === "P12W"
  //ou
  //statOffset === "P0D" et  endOffset === "P90D" supérieur ou pas à 1 trimestre ?
}

export const getStartAndEndAchievementPeriod = (startDate, endDateOccurence, achievementPeriod) => {
  let startAchievementPeriod = startDate
  if (isDDMMYYYYDate(startDate)) {
    startAchievementPeriod = moment.utc(startDate, "DD/MM/YYYY").toISOString()
  }
  if (achievementPeriod && achievementPeriod.startOffset) {
    let offsetDuration = achievementPeriod.startOffset
    startAchievementPeriod = getIsoDateFromStartAndPeriod(startDate, offsetDuration)
  }
  let endAchievementPeriod = endDateOccurence
  if (isDDMMYYYYDate(endDateOccurence)) {
    endAchievementPeriod = moment.utc(endDateOccurence, "DD/MM/YYYY").toISOString()
  }
  if (achievementPeriod && achievementPeriod.endOffset) {
    let offsetDuration = achievementPeriod.endOffset
    endAchievementPeriod = getIsoDateFromStartAndPeriod(startDate, offsetDuration)
  }
  return {
    startAchievementPeriod,
    endAchievementPeriod,
  }
}

export const getIsoStringFromDDMMYYYY = date => {
  if (isDDMMYYYYDate(date)) {
    return moment.utc(date, "DD/MM/YYYY").toISOString()
  }
  return undefined
}

export const achievementPeriodIsInRange = params => {
  const { rowStartDate, rowEndDate, startAchievementPeriod, endAchievementPeriod } = params

  const isoRowStartDate = getIsoStringFromDDMMYYYY(rowStartDate)
  const isoRowEndDate = getIsoStringFromDDMMYYYY(rowEndDate)

  const isBefore = endAchievementPeriod < isoRowStartDate
  const isAfter = isoRowEndDate < startAchievementPeriod
  const isOutside = isBefore || isAfter
  return !isOutside
}

/**
 * Finegan uniquement : la période contrôlée (coverage) d'un contrôle, si elle est renseignée.
 * C'est le seul champ temporel réellement configuré côté finegan (calendrier "Période contrôlée").
 * Renvoie null si l'une des bornes manque → l'appelant retombe alors sur le placement historique.
 */
export const getCoveragePeriod = occurrence => {
  const start = occurrence?.control?.startCoveragePeriod
  const end = occurrence?.control?.endCoveragePeriod
  if (!start || !end) return null
  return { start, end }
}

/**
 * Chevauchement entre le mois de la ligne du planning et la période contrôlée (bornes ISO).
 * Même logique que achievementPeriodIsInRange, appliquée à la période contrôlée.
 */
export const coveragePeriodIsInRange = params => {
  const { rowStartDate, rowEndDate, startCoveragePeriod, endCoveragePeriod } = params

  const isoRowStartDate = getIsoStringFromDDMMYYYY(rowStartDate)
  const isoRowEndDate = getIsoStringFromDDMMYYYY(rowEndDate)

  const isBefore = endCoveragePeriod < isoRowStartDate
  const isAfter = isoRowEndDate < startCoveragePeriod
  const isOutside = isBefore || isAfter
  return !isOutside
}

/**
 * Finegan uniquement : une occurrence dont la date de début dépasse la date de fin de validité
 * du contrôle (control.endDate) ne doit jamais être affichée. Ça évite les occurrences générées
 * bien au-delà de la validité (ex. une annuelle qui remonterait jusqu'en 2028+).
 */
export const occurrenceStartsAfterControlEnd = occurrence => {
  const controlEndDate = occurrence?.control?.endDate
  if (!controlEndDate) return false
  const start = moment(occurrence?.startDateOccurence, "DD/MM/YYYY")
  const end = moment(controlEndDate, "DD/MM/YYYY")
  if (!start.isValid() || !end.isValid()) return false
  return start.isAfter(end, "day")
}

export const getOccurrencesToDisplayOnRow = (occurrences, params, isFinegan) => {
  const { rowStartDate, rowEndDate, nbCardsToDisplayHorizontaly, useAchievementPeriod } = params

  const occurrencesOnRow = occurrences.filter(occurrence => {
    // Finegan : on n'affiche jamais une occurrence au-delà de la date de fin de validité du contrôle.
    if (isFinegan && occurrenceStartsAfterControlEnd(occurrence)) return false

    // Finegan avec période contrôlée : le placement suit la période contrôlée (le seul champ
    // temporel réellement configuré), et non plus la fenêtre d'occurrence annuelle fabriquée.
    // Sans période contrôlée (ou hors finegan), on garde le placement historique.
    const coveragePeriod = isFinegan ? getCoveragePeriod(occurrence) : null
    if (coveragePeriod) {
      return coveragePeriodIsInRange({
        rowStartDate,
        rowEndDate,
        startCoveragePeriod: coveragePeriod.start,
        endCoveragePeriod: coveragePeriod.end,
      })
    }

    // Comportement historique : l'occurrence s'affiche sur tous les mois que sa période couvre.
    const occcuIsBetweenDate = displayControlPlanning(occurrence, rowStartDate, rowEndDate)
    if (!useAchievementPeriod) return occcuIsBetweenDate

    const { startAchievementPeriod, endAchievementPeriod } = occurrence
    const inRangeParams = { rowStartDate, rowEndDate, startAchievementPeriod, endAchievementPeriod }
    return occcuIsBetweenDate && achievementPeriodIsInRange(inRangeParams)
  })

  let occurrencesToShow = occurrencesOnRow
  if (isFinegan) {
    // on veut les occurrences d'abord non répondu, puis en cours, et ainsi de suite jusqu'au statut les plus "haut"
    occurrencesToShow = sortOccurrencesByResponseStatus(occurrencesOnRow)
  }

  return occurrencesToShow.splice(0, nbCardsToDisplayHorizontaly)
}

export const sortOccurrencesByResponseStatus = (occurrences = []) => {
  if (!occurrences || !Array.isArray(occurrences)) return []
  return [...occurrences].sort((a, b) => {
    const statusA = a?.responseStatus
    const statusB = b?.responseStatus

    const indexA = statusA ? listResponseStatus99.indexOf(statusA) : -1
    const indexB = statusB ? listResponseStatus99.indexOf(statusB) : -1

    // Sans statut = priorité maximale (index -1)
    if (indexA === -1 && indexB !== -1) return -1
    if (indexA !== -1 && indexB === -1) return 1
    if (indexA === -1 && indexB === -1) return 0

    return indexA - indexB
  })
}

export const getIfControlClosed = (control, numberWeekCard) => {
  let isClosed
  let dateToday = new Date()
  let dateTodayTimeStamp = dateToday.setHours(0, 0, 0, 0)
  const currentWeek = moment().week()
  if (control.endDate) {
    const firstDayWeek = moment().startOf("week").format("DD/MM/YYYY")
    const lastDayWeek = moment().endOf("week").format("DD/MM/YYYY")
    const firstDayWeekTimeStamp = moment(firstDayWeek, "DD/MM/YYYY").format("x")
    const lastDayWeekTimeStamp = moment(lastDayWeek, "DD/MM/YYYY").format("x")
    // ================ Date Occurence AVANT modif ======================
    // const controlStartDateTimeStamp = moment(control?.startDate, "DD/MM/YYYY").format("x")
    // const controlEndDateTimeStamp = moment(control?.endDate, "DD/MM/YYYY").format("x")
    // ================ Date Occurence Après modif ======================
    const controlStartDateTimeStamp =
      moment(getDDMMYYYYFromMMDDYYYY(control?.startDateOccurence)).format("X") * 1000
    const controlEndDateTimeStamp =
      moment(getDDMMYYYYFromMMDDYYYY(control?.endDateOccurence)).format("X") * 1000
    const timeStampInfos = {
      planningStart: firstDayWeekTimeStamp,
      planningEnd: lastDayWeekTimeStamp,
      controlStart: controlStartDateTimeStamp,
      controlEnd: controlEndDateTimeStamp,
    }
    // ================ Ancienne Comparaison des dates ================
    // const getCompareDates = controlShouldBeDisplayOnPlanning(timeStampInfos)
    // isClosed = !getCompareDates
    // ================ Nouvelle Comparaison des dates ================
    const getCompareDates =
      controlStartDateTimeStamp <= dateTodayTimeStamp &&
      dateTodayTimeStamp <= controlEndDateTimeStamp
    isClosed = !getCompareDates
  } else {
    isClosed = numberWeekCard !== currentWeek
  }
  return isClosed
}

export const getIfPastControlDate = (control, numberWeekCard) => {
  let isControlPast = false
  let dateToday = new Date()
  let dateTodayTimeStamp = dateToday.setHours(0, 0, 0, 0)
  const currentWeek = moment().week()
  if (control.endDate) {
    const firstDayWeek = moment().startOf("week").format("DD/MM/YYYY")
    const lastDayWeek = moment().endOf("week").format("DD/MM/YYYY")
    const firstDayWeekTimeStamp = moment(firstDayWeek, "DD/MM/YYYY").format("x")
    const lastDayWeekTimeStamp = moment(lastDayWeek, "DD/MM/YYYY").format("x")
    // ================ Date Occurence ======================
    const controlStartDateTimeStamp =
      moment(getDDMMYYYYFromMMDDYYYY(control?.startDateOccurence)).format("X") * 1000
    const controlEndDateTimeStamp =
      moment(getDDMMYYYYFromMMDDYYYY(control?.endDateOccurence)).format("X") * 1000
    // ================ Comparaison des dates ================
    if (
      controlStartDateTimeStamp <= dateTodayTimeStamp &&
      dateTodayTimeStamp <= controlEndDateTimeStamp
    ) {
      isControlPast = false
    } else if (controlStartDateTimeStamp <= dateTodayTimeStamp) {
      isControlPast = true
    } else {
      isControlPast = false
    }
  }
  return isControlPast
}

export const verifyIfDatesAreInvalid = parametersControl => {
  let error = false
  const startDateTimeStamp = moment(parametersControl?.startDate, "DD/MM/YYYY").format("x")
  const endDateTimeStamp = moment(parametersControl?.endDate, "DD/MM/YYYY").format("x")
  if (startDateTimeStamp > endDateTimeStamp) error = true
  return error
}

export const findNameControlPlan = (listControlPlans, control) => {
  let controlPlanName = ""
  if (!Array.isArray(listControlPlans)) return controlPlanName
  const controlPlanFound = listControlPlans.find(
    controlPlan => controlPlan?._id?.$oid === control?.controlPlanId
  )
  if (controlPlanFound) controlPlanName = controlPlanFound?.name
  return controlPlanName
}

export const transformTemplateToControlList = templateList => {
  if (!Array.isArray(templateList)) return []
  return templateList.map(item => {
    return {
      ...item?.control,
      statut: item?.template?.statut,
      conformity: item?.conformity,
      nameRespondant: item?.nameRespondant,
    }
  })
}

export const getColorAccordingConformity = conformity => {
  let color = "black"
  if (conformity === "Conforme") color = greenValid
  if (conformity === "Non Conforme") color = redError
  return color
}

export const getStatusDocSollicite = (doc, trad) => {
  let text = ""
  if (!doc || !trad) return text
  let textColor = ""
  const status = doc?.status
  const lastUpdatedDate = doc?.updateDate
  if (doc?.fileName === "") {
    text = trad[status]
    textColor = redError
  } else {
    text = moment(lastUpdatedDate).format("DD/MM/YYYY")
    textColor = greenValid
  }
  return <span style={{ color: textColor, fontWeight: "bold", width: "100px" }}>{text}</span>
}

export const userCannotAnswerControl = params => {
  const { occurenceStatus, templateStatus, businessTag } = params

  const isOccurenceClosed = occurenceStatus === "closed"
  const isControlSwanDraft = templateStatus === "draft"

  const isControlSwan = businessTag === "swan"
  const isControl99 = businessTag === "99advisory"

  let isLocked = isOccurenceClosed
  if (isControlSwan) isLocked = isOccurenceClosed || isControlSwanDraft
  if (isControl99) isLocked = isOccurenceClosed
  return isLocked
}

export const controlIsReadOnlyDependingOnFrequence = (
  dateStartOccurenceInTimeStamp,
  occurenceStatus,
  frequenceControl
) => {
  const timeStampToday = new Date().setHours(0, 0, 0, 0)
  const dateEndOccurenceInTimeStamp = getDateInTimeStampFrequenceControl(
    dateStartOccurenceInTimeStamp,
    frequenceControl
  )
  // const controlIsStillValid =
  //   dateStartOccurenceInTimeStamp > timeStampToday || timeStampToday > dateEndOccurenceInTimeStamp
  const controlIsStillValid = dateStartOccurenceInTimeStamp > timeStampToday
  const controlIsFinished =
    occurenceStatus === "finished" ||
    occurenceStatus === "closedReadOnly" ||
    occurenceStatus === "closed"
  return controlIsStillValid || controlIsFinished
}

export const getDateInTimeStampFrequenceControl = (occurenceDateStart, frequence) => {
  const addOneDayTimeStamp = 24 * 60 * 60 * 1000
  switch (frequence) {
    case "Hebdomadaire":
      return occurenceDateStart + addOneDayTimeStamp * 7
    case "Mensuelle":
      return getOcurrenceEndDateInTimeStampOnPeriod(occurenceDateStart, 1, "months")
    case "Trimestrielle":
      return getOcurrenceEndDateInTimeStampOnPeriod(occurenceDateStart, 3, "months")
    case "Semestrielle":
      return getOcurrenceEndDateInTimeStampOnPeriod(occurenceDateStart, 6, "months")
    case "Annuelle":
      return getOcurrenceEndDateInTimeStampOnPeriod(occurenceDateStart, 1, "year")
    default:
      return occurenceDateStart
  }
}

export const getOcurrenceEndDateInTimeStampOnPeriod = (occurenceDateStart, nbMonth, typePeriod) => {
  const dateAddNbMonth = moment(occurenceDateStart).add(nbMonth, typePeriod)
  const dateEndOccurence = moment(dateAddNbMonth).format("X") * 1000
  return dateEndOccurence
}

export const getOcurrenceEndDateOnPeriod = (occurenceDateStart, nbPeriod, typePeriod) => {
  const dateStarOccurenceMoment = getDDMMYYYYFromMMDDYYYY(occurenceDateStart)
  const dateEndOccurenceMomentTmp = moment(dateStarOccurenceMoment).add(nbPeriod, typePeriod)
  // On retire une journée a la date de fin pour avoir la bonne période de réponse
  const dateEndOccurenceMoment = moment(dateEndOccurenceMomentTmp).subtract(1, "days")
  const dateEndOccurence = dateEndOccurenceMoment?.format("DD/MM/YYYY")
  return dateEndOccurence
}

export const getEndDateOnPeriod = (dateStart, period) => {
  switch (period) {
    case "Hebdomadaire":
      return getOcurrenceEndDateOnPeriod(dateStart, 7, "days")
    case "Mensuelle":
      return getOcurrenceEndDateOnPeriod(dateStart, 1, "months")
    case "Trimestrielle":
      return getOcurrenceEndDateOnPeriod(dateStart, 3, "months")
    case "Semestrielle":
      return getOcurrenceEndDateOnPeriod(dateStart, 6, "months")
    case "Annuelle":
      return getOcurrenceEndDateOnPeriod(dateStart, 1, "year")
    default:
      return dateStart
  }
}

export const getControlsFromAllControlPlans = controlsPlansWithControls => {
  if (!Array.isArray(controlsPlansWithControls)) return []
  const controls = []
  controlsPlansWithControls.forEach(controlPlan => {
    if (controlPlan.hasOwnProperty("controls")) controls.push(...controlPlan?.controls)
  })
  return controls
}

export const getBadgeNumberAlertUser = (numberElementToAlert, is1400resolution) => {
  if (numberElementToAlert === 0) return
  const styleBadge = {
    width: is1400resolution ? "20px" : "30px",
    height: is1400resolution ? "20px" : "30px",
    backgroundColor: "#dd3300",
    borderRadius: "50%",
    position: "absolute",
    top: "-30%",
    right: "-10%",
    color: "white",
    boxShadow: "2px 2px 2px rgba(0, 0, 0, 0.3)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    animation: "pulse 1000ms linear infinite",
  }
  return <div style={styleBadge}>{numberElementToAlert > 99 ? `99+` : numberElementToAlert}</div>
}

// *************************************
// FUNCTIONS TO TRANSLATE
// *************************************
export const getConformityTranslated = (conformity, trad, useConformityScale) => {
  let label = ""
  if (useConformityScale && isObject(conformity)) {
    label = conformity?.label
  }

  if (!label && conformity === "à réaliser") {
    label = trad?.NOT_STARTED
  } else if (!label && conformity === "en cours") {
    label = trad?.IN_PROGRESS
  } else if (!label && conformity === "Terminé") {
    label = trad?.ENDED
  } else if (!label && conformity === "Conforme") {
    label = trad?.CONFORM
  } else if (!label && conformity === "Non Conforme") {
    label = trad?.NOT_CONFORM
  } else if (!label && conformity === "Non conforme") {
    label = trad?.NOT_CONFORM
  } else if (!label && conformity === "Partiellement conforme avec un faible impact") {
    label = trad?.LOW_CONFORM
  } else if (!label && conformity === "Partiellement conforme avec un fort impact") {
    label = trad?.STRONG_CONFORM
  } else if (!label && conformity === "NA") {
    label = "NA"
  }
  return label
}

export const checkIfValueIsConformity = (value, trad, typeQuestion) => {
  const conformity = value?.split(" / ")

  if (
    conformity?.length == 2 &&
    (conformity?.[0]?.includes("à réaliser") ||
      conformity?.[0]?.includes("en cours") ||
      conformity?.[0]?.includes("Terminé") ||
      conformity?.[0]?.includes("Conforme") ||
      conformity?.[0]?.includes("Non Conforme") ||
      conformity?.[0]?.includes("Non conforme") ||
      conformity?.[0]?.includes("Partiellement conforme avec un faible impact") ||
      conformity?.[0]?.includes("Partiellement conforme avec un fort impact") ||
      conformity?.[0]?.includes("NA"))
  ) {
    return `${getConformityTranslated(conformity?.[0], trad)} / ${conformity?.[1]}`
  } else return getTranslatedTypeQuestion(value, typeQuestion, trad)
}

export const getTranslatedTypeQuestion = (value, typeQuestion, trad) => {
  if (typeQuestion === "boolean" || typeQuestion === "boolean_NA")
    return getYesNoTranslated(value, trad)
  if (typeQuestion === "conformite") return getConformityTranslated(value, trad)
  else return value
}

export const getPeriodTranslated = (period, trad) => {
  if (period === "Quotidienne") return trad?.DAILY
  if (period === "Hebdomadaire") return trad?.WEEKLY
  if (period === "Mensuelle") return trad?.MONTHLY
  if (period === "Trimestrielle") return trad?.QUARTERLY
  if (period === "Semestrielle") return trad?.SEMI_ANNUAL
  if (period === "Annuelle") return trad?.ANNUAL
  else return ""
}

export const getTypeControlTranslated = (type, trad) => {
  if (type === "controle") return trad?.CONTROL
  if (type === "mitigant") return trad?.MITIGANT
  else return ""
}

export const getYesNoTranslated = (value, trad) => {
  if (value === "Oui" || value === "Yes") return trad?.YES
  if (value === "Non" || value === "No") return trad?.NO
  if (value === "NA") return trad?.NO_CONCERNED
  else return value
}

export const getSampleTranslated = (sample, trad) => {
  if (sample === "exhaustif") return trad?.EXHAUSTIVE
  if (sample === "echantillon") return trad?.SAMPLE_SINGULAR
  else return ""
}

export const getFrequencyTranslated = (frequency, trad) => {
  if (frequency === "Faible") return trad?.LOW
  if (frequency === "Modéré") return trad?.MODERATE
  if (frequency === "Elevée") return trad?.HIGH_FEMALE
  if (frequency === "Très élevée") return trad?.VERY_HIGH_FEMALE
  else return frequency
}

export const getRiskBrutTranslated = (riskBrut, trad) => {
  if (riskBrut === "Très faible") return trad?.VERYLOW
  if (riskBrut === "Faible") return trad?.LOW
  if (riskBrut === "Modéré") return trad?.MODERATE
  if (riskBrut === "Elevée") return trad?.HIGH
  if (riskBrut === "Très élevée") return trad?.VERY_HIGH
  if (riskBrut === "Critique") return trad?.CRITICAL
  else return riskBrut
}

export const getImpactTranslated = (impact, trad) => {
  if (impact === "Très faible") return trad?.VERYLOW
  if (impact === "Faible") return trad?.LOW
  if (impact === "Modéré") return trad?.MODERATE
  if (impact === "Fort") return trad?.HIGH
  if (impact === "Très fort") return trad?.VERY_HIGH
  else return impact
}

export const getColorStatusDoc = docStatus => {
  let color = "black"
  if (docStatus === "waiting") color = orangeModifications
  if (["validated", "added"].includes(docStatus)) color = greenValid
  if (docStatus === "rejected") color = redError
  return color
}

export const getStatusDocTranslated = (status, trad) => {
  if (status === "waiting") return trad?.WAITING
  if (status === "added") return trad?.ADDED
  if (status === "validated") return trad?.VALIDATED
  if (status === "rejected") return trad?.REJECTED
  else return ""
}

export const getControlStatus99advisoryTranslated = (status, trad) => {
  if (!trad) return ""
  // CONTROL STATUS
  if (status === "notAffected") return trad?.NOT_AFFECTED
  if (status === "affectedToConsultant") return trad?.AFFECTED_TO_CONSULTANT
  if (status === "waitingForControlModificationsValidation")
    return trad?.WAITING_FOR_CONTROL_MODIFICATIONS_VALIDATION
  if (status === "readyToBeAnswered") return trad?.NOT_STARTED
  // RESPONSE STATUS
  if (status === "draft") return trad?.IN_PROGRESS
  if (status === "validated") return trad?.AWAITING_VALIDATION_MANAGER
  if (status === "validatedByManager") return trad?.AWAITING_VALIDATION_CUSTOMER
  if (status === "validatedByClient") return trad?.ENDED
  else return ""
}
// Récupération de la traduction des valeurs de type_of_control
export const getTypeOfControlTranslated = (value, trad) => {
  const typeOfControlValue = Array.isArray(value) ? value : []
  if (typeOfControlValue?.length > 0) {
    const typeOfControlSelectOptions = getTypeOfControlSelectOptions(trad)
    const valueSelected = filter(typeOfControlSelectOptions, item =>
      includes(typeOfControlValue, item?.value)
    )
    return join(
      valueSelected?.map(item => item?.label),
      ","
    )
  } else {
    return ""
  }
}

export const getParametersTranslation = trad => {
  if (!isObjectV2(trad)) return ""
  return {
    reference: trad?.REFERENCE,
    process: trad?.PROCESS,
    color: trad?.COLOR_LOWER_CASE,
    sample: trad?.SAMPLE,
    riskApproach: trad?.RISK_APPROACH,
    referenceRegulatory: trad?.REGULATORY_REFERENCE,
    objectifControl: trad?.OBJECTIF_CONTROL,
    department: trad?.CONCERNED_DEPARTMENTS,
    thematic: trad?.TOPIC,
    startCoveragePeriod: trad?.START_CONTROLLED_PERIOD,
    endCoveragePeriod: trad?.END_CONTROLLED_PERIOD,
    requestedDocuments: trad?.DOCUMENT_TAB_PLURAL,
    activities: trad?.ACTIVTY_TAB,
    risks: trad?.RISKS,
    comments_sample: trad?.COMMENTS_ECHANTILLON,
    startDate: trad?.START_DATE,
    endDate: trad?.END_DATE,
    mappingRiskName: trad?.MAPPING_RISK,
    type_control: trad?.TYPE_CONTROL,
    level: trad?.LEVEL,
    description: trad?.DESCRIPTION,
    creatorName: trad?.CREATOR_NAME,
    activityNames: trad?.SECTOR_ACTIVITY,
    controlPlanName: trad?.CONTROL_PLAN,
    riskImpact: trad?.RISK_LEVEL,
    clientName: trad?.CONCERNED_CLIENT,
    creatorId: trad?.CREATOR_NAME,
    period: trad?.FREQUENCE_CONTROL,
    targetUsers: trad?.CONTROLLERS,
    thematicLabel: trad?.TOPIC,
    controlsParentsNames: trad?.ASSOCIATED_CONTROLS,
    controlOpenedBy: trad?.CONTROL_OPENED_BY,
    assignedTo: trad?.ASSIGNED_TO,
    dateCompletionControl: trad?.DATE_OF_COMPLETION_CONTROL,
    regulatoryReference: trad?.REGULATORY_REFERENCE,
    type_of_control: trad?.TYPE_OF_CONTROL,
    agence: trad?.AGENCE,
    // Recommendations99
    controlPointName: trad?.CHECKPOINT,
    notation: trad?.COMPLIANCE_DEGREES,
    priority: trad?.PRIORITY,
    followUpDate: trad?.FOLLOW_UP_DATE,
    status: trad?.STATUS,
    dueDate: trad?.DUE_DATE,
    // This is key for execution time parameter, estimation
    executionTime: trad?.TIMER_CONTROL_LABEL,
    // This is key for real exeution time was executed
    executionTimer: trad?.EXECUTION_TIME_CONTROL_LABEL,
    occurenceDate: trad?.DATE_OF_COMPLETION,
    creationDate: trad?.CREATION_DATE,
    evolution: trad?.EVOLUTION,
  }
}

export const getNameSectorById = (activityList, activityId, trad) => {
  const activity = Array.isArray(activityList)
    ? activityList?.find(sector => sector?.value === activityId)?.label
    : activityId
  const translatedActivity = ""
  return activity
}

export const getThematicTranslated = (thematic, trad) => {
  if (!thematic || !isObjectV2(trad)) return ""
  if (thematic === "administration_et_pilotage")
    return trad?.ADMINISTRATION_AND_MANAGEMENT_OF_THE_COMPANY
  if (thematic === "relation_clients") return trad?.CUSTOMER_RELATIONSHIPS
  if (thematic === "gestion_fonds_operations") return trad?.FUNDS_MANAGEMENT_AND_OPERATIONS
  if (thematic === "conformite_deontologie_risque_cybersecurite")
    return trad?.COMPLIANCE_ETHICS_RISKS_AND_CYBERSECURITY
}

export const getOccurenceCardStatus = (controlStatus, responseStatus) => {
  if (responseStatus) return responseStatus
  if (controlStatus) return controlStatus
  return "readyToBeAnswered"
}

//OLD PLANNING
export const getCardsFilteredByControlId = (cardsList, filterControlId) => {
  if (!filterControlId) return cardsList
  return cardsList.filter(card => card?.control?._id?.$oid === filterControlId)
}

//NEW PLANNING
export const getOccurrencesFilteredByControlId = (occurrences, filterControlId) => {
  if (!filterControlId) return occurrences
  return occurrences.filter(occu => occu?.controlId === filterControlId)
}

export const getCardsFilteredByManager = (cardsList, filterManager) => {
  if (!filterManager) return cardsList
  return cardsList.filter(card => {
    const managersAssociate = card?.controlPlanResponsiblesIds
    if (Array.isArray(managersAssociate)) return managersAssociate.includes(filterManager)
    return card
  })
}

export const getCardsFilteredByClient = (cardsList, filterClient) => {
  if (!filterClient) return cardsList
  return cardsList.filter(card => card?.clientId === filterClient)
}

export const getCardsFilteredByStatus = (cardsList, filterStatus) => {
  if (!filterStatus) return cardsList
  return cardsList.filter(card => card?.occurenceStatus === filterStatus)
}

export const getCardsFilteredByConformite = (cardsList, filterConformite, useConformityScale) => {
  if (!filterConformite) return cardsList
  if (useConformityScale) {
    return cardsList.filter(
      card => card?.conformity === filterConformite || card?.conformity?.label === filterConformite
    )
  }
  return cardsList.filter(card => card?.conformity === filterConformite)
}

export const getUserNameById = (userId, users) => {
  if (!Array.isArray(users) || !userId) return ""
  const userFounded = users.find(user => userId === user.USER_ID)
  if (userFounded) return `${userFounded.FIRSTNAME} ${userFounded.LASTNAME}`
  else return ""
}

export const getUsersNameByIds = (usersId, usersList) => {
  if (!Array.isArray(usersId) || !Array.isArray(usersList)) return []
  const usersFound = []
  usersList.forEach(user => {
    if (usersId.includes(user.USER_ID)) usersFound.push(`${user?.FIRSTNAME} ${user?.LASTNAME}`)
  })
  return usersFound
}

export const getMostRecentStatusInHistory = (history, statusToGet) => {
  if (!Array.isArray(history) || !statusToGet) return {}
  const filteredHistory = history.filter(hist => hist?.newStatus === statusToGet)
  const sortedByDateHistory = filteredHistory.sort((a, b) => {
    return new Date(b.date) - new Date(a.date)
  })
  if (!sortedByDateHistory.length) return {}
  return sortedByDateHistory[0]
}

export const getFormatedDate = date => {
  if (!date) return ""
  return new Date(date).toLocaleDateString("fr")
}

export const getControlConformityStatus = (responseObject, comparaisonDefaultConformity) => {
  if (!responseObject) return "à réaliser"
  const isDraftResponse = responseObject?.status === "draft"
  if (isDraftResponse) return "en cours"
  const responseFields = responseObject?.reponse
  if (!Array.isArray(responseFields)) return "à réaliser"
  const resultFields = responseFields.filter(res => res?.result)
  // check si les resultat sont des calculs dans une section
  const resultFieldsMapCalculSection = map(resultFields, res => {
    const splitId = split(res?.idQuestion, "_")
    const idSection =
      splitId?.length > 3 ? `${splitId[0]}_${splitId[1]}_${splitId[2]}` : "no_section"
    const isCalculSection =
      idSection === "resultat_conformite_session" || idSection === "resultat_conformite_section"
    return {
      ...res,
      isCalculSection: isCalculSection,
    }
  })
  const resultFieldsFilterCalculSection = filter(
    resultFieldsMapCalculSection,
    res => !res?.isCalculSection
  )
  const calculResultFields = responseFields.filter(res => res?.calculResult)
  let conformity = "à réaliser"
  if (resultFields?.length && resultFieldsFilterCalculSection?.length !== 0) {
    conformity = resultFieldsFilterCalculSection[0]?.value_question
  } else if (
    responseObject?.status === "validated" &&
    resultFieldsFilterCalculSection?.length === 0
  ) {
    conformity = "Terminé"
  } else if (calculResultFields.length) {
    conformity = getConformityDegreeConformity(calculResultFields, comparaisonDefaultConformity)
  }

  return conformity
}

export const getBusinessGroups = businessGroups => {
  if (!Array.isArray(businessGroups)) return []
  return businessGroups?.map(business => {
    return {
      value: business?._id?.$oid,
      label: business?.name,
    }
  })
}

export const findClientLogoWithClientId = (allBusinessGroups, myBusinessGroups, clientId) => {
  if (!Array.isArray(allBusinessGroups) || !Array.isArray(myBusinessGroups) || !clientId) return ""
  const groupsToSearch = [...allBusinessGroups, ...myBusinessGroups]
  const groupClientFound = groupsToSearch.find(client => client?._id?.$oid === clientId)
  const groupClientLogo = groupClientFound?.moreInformations?.logo
  return groupClientLogo
}

export const getStringWithoutHTML = string => {
  if (typeof string !== "string") return ""
  const div = document.createElement("div")
  div.innerHTML = string
  return div.innerText
}

export const findCardOccurency = (cardsList, responseId) => {
  if (!Array.isArray(cardsList) || !responseId) return null
  const foundOccurency = cardsList.find(card => card?.idResponse?.$oid === responseId)
  return foundOccurency ? foundOccurency : null
}

export const findOccurencyFromRespId = (occurrences, responseId) => {
  if (!Array.isArray(occurrences) || !responseId) return undefined
  return occurrences.find(occurrence => occurrence?.responseId === responseId)
}

export const getIfOnlyManagerAreAssociateControl = (businessTag, users, controlTargetIds) => {
  if (!businessTag || !Array.isArray(users) || !Array.isArray(controlTargetIds)) return false
  const is99Advisory = businessTag === tag99Advisory
  if (!is99Advisory) return false
  const usersAssociate = users.filter(user => controlTargetIds.includes(user?.USER_ID))
  if (!usersAssociate?.length) return false
  const usersAssociateAreManager = usersAssociate.every(user => isAdministrator(user))
  return usersAssociateAreManager
}

export const addDays = (date, days) => {
  const result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

export const filtredOccurrencesByAchievementPeriod = occurrences => {
  const removeOccurences = []
  const now = new Date().toISOString()
  for (const occurrence of occurrences) {
    // if (occurrence?.controlReference === "CE-2025") {
    // console.log("occurrence?.controlReference: ", occurrence?.controlReference)
    // console.log("startAchievementPeriod: ", occurrence?.startAchievementPeriod)
    // console.log("endAchievementPeriod: ", occurrence?.endAchievementPeriod)
    // }
    // console.log("addDays(occurrence?.endAchievementPeriod, 10): ", addDays(occurrence?.endAchievementPeriod, 10).toISOString())
    // console.log("occurrence?.endAchievementPeriod: ", occurrence?.endAchievementPeriod)
    // console.log("now: ", now)
    if (
      occurrence?.endAchievementPeriod &&
      occurrence?.startAchievementPeriod &&
      addDays(occurrence?.endAchievementPeriod, 10).toISOString() > now
    ) {
      removeOccurences.push(occurrence)
    }
  }
  return removeOccurences
}

export const getFilteredOccurrences = (occurrences, params) => {
  const {
    filterClient,
    filterControlId,
    filterStatus,
    filterConformite,
    useConformityScale,
    todayFirstTimeStamp = new Date().setHours(0, 0, 0, 0),
  } = params

  const occurencesFilteredByAchievementPeriod = filtredOccurrencesByAchievementPeriod(occurrences)

  const filteredOccurrences = occurencesFilteredByAchievementPeriod.filter(occu => {
    if (filterClient && occu?.clientId !== filterClient) return false
    if (filterControlId && occu?.controlId !== filterControlId) return false
    if (filterStatus && occu?.occurenceStatus !== filterStatus) return false
    if (filterConformite && useConformityScale) {
      if (![occu?.conformity, occu?.conformity?.label].includes(filterConformite)) return false
    }
    if (filterConformite && !useConformityScale) {
      if (occu?.conformity !== filterConformite) return false
    }
    return true
  })

  const cardsListSortedByDate = getCardsListSortedByDate(filteredOccurrences)
  return hideCardsPast(cardsListSortedByDate, true, todayFirstTimeStamp)
}
